import { ApiService } from './ApiService';
import apiResponse, { ApiResponse } from './ApiResponse';

export interface JobScheduler {
  key: string;
  name: string;
  id: string | null;
  endDate: number | null;
  tz: string | null;
  pattern: string;
  next: number;
}

export interface DelayedJob {
  id: string;
  name: string;
  data: Record<string, unknown>;
  delay: number;
  timestamp: number;
  processedOn: number | null;
  opts: Record<string, unknown>;
}

export class JobStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async getSchedulers(): Promise<ApiResponse<JobScheduler[]>> {
    try {
      const result = await this.api.get('admin/jobs/schedulers');
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async getDelayedJobs(): Promise<ApiResponse<DelayedJob[]>> {
    try {
      const result = await this.api.get('admin/jobs/delayed');
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }

  public async removeScheduler(schedulerKey: string): Promise<ApiResponse<{ success: boolean; message: string }>> {
    try {
      const result = await this.api.delete(`admin/jobs/schedulers/${encodeURIComponent(schedulerKey)}`);
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
